// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default, Option, OptionSection } from "./Select";
export type {
  SelectProps,
  SelectOption,
  SelectSection,
  SelectChangeEvent,
  SelectChangeTarget,
} from "./Select";
